{
  "customer-register-dialog": {
    "buttons": {
      "cancel": "Hủy bỏ",
      "next": "Kế tiếp"
    },
    "text": {
      "book_as_guest": "Đặt lịch như khách vãng lai",
      "login": "đăng nhập",
      "or": " hoặc ",
      "register": "đăng ký",
      "to_manage": "Để quản lý tất cả lịch hẹn và salon yêu thích của bạn, vui lòng "
    }
  }
}
